document.addEventListener("DOMContentLoaded", () => {
  const headerSlideshow = document.querySelector(
    ".dialog-off-canvas-main-canvas .bg-svgs.svg-header-slideshow"
  );

  if (headerSlideshow) {
    let counter = 0;
    let i = 1;
    let slideshow_timer;

    headerSlideshow.insertAdjacentHTML(
      "beforeend",
      '<div class="header-slideshow-pagers"></div>'
    );
    headerSlideshow
      .querySelector(".header-slideshow-pagers")
      .insertAdjacentHTML("beforeend", '<div class="pagers"></div>');

    headerSlideshow
      .querySelectorAll(
        ".bg-svgs.svg-header-slideshow div.field-slideshow > div"
      )
      .forEach(function (slideshowItem) {
        slideshowItem.classList.add("slideshow");
        counter++;

        let pagerNumber = counter;

        headerSlideshow
          .querySelector(".header-slideshow-pagers .pagers")
          .insertAdjacentHTML(
            "beforeend",
            '<div class="pager" number="' + pagerNumber + '"></div>'
          );

        slideshowItem.setAttribute("counter", counter);

        if (counter === 1) {
          slideshowItem.classList.add("active");
        }
      });

    headerSlideshow
      .querySelector(".header-slideshow-pagers .pagers .pager:first-child")
      .classList.add("active");

    function NextSlideshow() {
      if (i === counter) {
        i = 1;
      } else {
        i++;
      }

      headerSlideshow
        .querySelectorAll(
          ".bg-svgs.svg-header-slideshow div.field-slideshow > div"
        )
        .forEach(function (slideshowItem) {
          slideshowItem.classList.remove("active");
          if (parseInt(slideshowItem.getAttribute("counter")) === i) {
            slideshowItem.classList.add("active");
          }
        });

      headerSlideshow
        .querySelectorAll(
          ".dialog-off-canvas-main-canvas .header-slideshow-pagers .pagers .pager"
        )
        .forEach(function (pager) {
          pager.classList.remove("active");
          if (parseInt(pager.getAttribute("number")) === i) {
            pager.classList.add("active");
          }
        });
    }

    slideshow_timer = setInterval(function () {
      NextSlideshow();
    }, 4000);

    headerSlideshow
      .querySelectorAll(
        ".dialog-off-canvas-main-canvas .header-slideshow-pagers .pagers .pager"
      )
      .forEach(function (pager) {
        pager.addEventListener("click", function (e) {
          i = parseInt(pager.getAttribute("number"));

          headerSlideshow
            .querySelectorAll(
              ".bg-svgs.svg-header-slideshow div.field-slideshow > div"
            )
            .forEach(function (slideshowItem) {
              slideshowItem.classList.remove("active");
              if (parseInt(slideshowItem.getAttribute("counter")) === i) {
                slideshowItem.classList.add("active");
              }
            });

          headerSlideshow
            .querySelectorAll(
              ".dialog-off-canvas-main-canvas .header-slideshow-pagers .pagers .pager"
            )
            .forEach(function (pager) {
              pager.classList.remove("active");

              if (parseInt(pager.getAttribute("number")) === i) {
                pager.classList.add("active");
              }
            });

          clearInterval(slideshow_timer);
          slideshow_timer = setInterval(function () {
            NextSlideshow();
          }, 4000);
        });
      });
  }
});